<script>
// 赛事信息
import { QNImageUtil } from '@/utils'

export default {
  name: 'MatchInfo',
  props: {
    matchTopInfo: {
      type: Object,
      required: true
    }
  },
  computed: {
    logoUrl() {
      return QNImageUtil.originView(this.matchTopInfo.logoUrl) || ''
    }
  },
  methods: {
    
  }
}
</script>

<template>
  <div class="match-info flex bg2 padding-12">
    <div class="match-logo relative">
      <img :src="logoUrl" alt="logo">
      <div class="pv color-white"><van-icon name="eye" /> {{ matchTopInfo.totalPV }}</div>
    </div>
    <div class="match-info-right relative">
      <div class="name font-color1">{{ matchTopInfo.name }}</div>
      <div class="status" v-if="matchTopInfo.status && matchTopInfo.status === '报名中'">{{ matchTopInfo.status }}</div>
      <div class="address color-white">{{ matchTopInfo.address }}</div>
    </div>
  </div>
</template>

<style src="@/tbs/stylesheet/dynamic.css" />
<style scoped lang="scss">
.match-info { gap: 12px; }
.match-info-right { flex: 1; }
.match-logo {
  width: 110px;
  height: 110px;
  min-width: 110px;
  border-radius: 6px;
  overflow: hidden;
  background: #D8D8D8;
  img { width: 100%; height: 100%; }
  .pv {
    position: absolute;
    bottom: 0;
    left: 0;
    background: rgba(30, 30, 30, 0.35);
    border-radius: 75px;
    padding: 3px 6px;
    font-size: 10px;
  }
}
.name { font-size: 15px; font-weight: 500; }
.status {
  display: inline-block;
  background: #00B578;
  border-radius: 2px;
  padding: 2px 10px;
  font-size: 9px;
  color: #fff;
  margin-top: 8px;
}
.address {
  position: absolute;
  padding: 3px 6px;
  bottom: 0;
  right: 0;
  font-size: 10px;
  border-radius: 75px;
  background: rgba(30, 30, 30, 0.45);
}
</style>
